import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import FormField from '../form-field';
import Alert from '../../components/alert';

class NewPasswordForm extends Component {
  onSubmit(props) {
    this.props.onSubmit(props);
  }

  get fullNameField() {
    if (!this.props.askFullName) return null;
    return (
      <Field
        type="text"
        name="fullName"
        component={FormField}
        label={
          <FormattedMessage
            id="setNewPassword.fullNameField.label"
            defaultMessage="Full Name"
          />
        }
        subtext={
          <FormattedMessage
            id="setNewPassword.fullNameField.subtext"
            defaultMessage="Your account is missing this information"
          />
        }
      />
    );
  }

  renderAlert() {
    if (!this.props.error) return null;

    return (
      <Alert type="warning" className="alert-form-top">
        <i className="fa fa-fw fa-ban" />
        {this.props.error}
      </Alert>
    );
  }

  render() {
    const { handleSubmit, email } = this.props;
    return (
      <div>
        {this.renderAlert()}
        <div className="modal-title modal-section text-center divider">
          <h1>
            <FormattedMessage
              id="setNewPassword.title"
              defaultMessage="New password"
            />
          </h1>
          <p>
            <span className="text-muted">
              <FormattedMessage
                id="setNewPassword.subtitle"
                defaultMessage="Create a new password for {email}"
                values={{ email }}
              />
            </span>
          </p>
        </div>

        <div className="modal-section">
          <form onSubmit={handleSubmit(props => this.onSubmit(props))}>
            {this.fullNameField}
            <Field
              type="password"
              name="password"
              component={FormField}
              label={
                <FormattedMessage
                  id="setNewPassword.passwordField.label"
                  defaultMessage="Create password"
                />
              }
              subtext={
                <FormattedMessage
                  id="setNewPassword.password.subtext"
                  defaultMessage="It must be at least 8 characers long"
                />
              }
            />

            <button type="submit" className="btn btn-primary full-width">
              <FormattedMessage
                id="setNewPassword.submit"
                defaultMessage="Create new password"
              />
            </button>
          </form>
        </div>
      </div>
    );
  }
}

const validate = (values, props) => {
  const errors = {};

  if (!values.password || values.password.length < 8) {
    errors.password = <FormattedMessage
      id="setNewPassword.errors.badPassword"
      defaultMessage="Must be at least 8 characers long"
    />;
  }

  if (props.askFullName && (!values.fullName || values.fullName.indexOf(' ') < 0)) {
    errors.fullName = <FormattedMessage
      id="setNewPassword.errors.baddFullName"
      defaultMessage="Enter full name, separated with a space"
    />;
  }

  return errors;
};

export default reduxForm({ form: 'signupForm', validate })(NewPasswordForm);



// WEBPACK FOOTER //
// ./src/desktop/components/set-new-password/form.js